import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import React from 'react';
import { connect } from "react-redux";
import Alert from "../../../shared/utils/Alert";
import CustomPaper from '../../../shared/utils/CustomPaper';
import OneSalarieForm from './OneSalarieForm';

class ModifierUnSalarie extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};

    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let toReturn = nextProps.salaries.filter(x => x.id === nextProps.match.params.id_salarie)[0] || nextProps.salaries[0];
        toReturn = toReturn || null;
        for (let key in toReturn) {
            if (toReturn.hasOwnProperty(key) && key.startsWith('date_')) {
                toReturn[key] = new Date(toReturn[key]);
            }
        }
        return toReturn;
    }

    render() {
        const salaries = [];
        this.props.salaries.map(x => salaries.push(<MenuItem key={x.id} value={x.id}
            primaryText={x.nom + " " + x.prenom} />));

        return salaries.length > 0 ? (
            <div className={'container'}>
                <CustomPaper title='Modifier un salarié'>
                    <div className={'row justify-content-center'}>
                        <SelectField
                            value={this.state.id}
                            floatingLabelText='Salarié à modifier'
                            onChange={(x, y, z) => this.props.history.push('/entreprise/modifier_un_salarie/' + z)}
                            maxHeight={400}
                        >
                            {salaries}
                        </SelectField>
                    </div>
                    <OneSalarieForm
                        showEditButtons={true}
                        submitSuccessMsg="Modification effectuée avec succès."
                        submitBtnTxt='Modifier'
                        initialState={this.state}
                        submitMethod='PUT'
                    />
                </CustomPaper>
            </div>
        ) : <Alert text="Veuillez d' abord ajouter des salarié." />;
    }
}

function mapStateToProps(store) {
    return { salaries: store.entreprise.entreprise_infos.salaries }
}

export default connect(mapStateToProps)(ModifierUnSalarie);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/salaries/ModifierUnSalarie.js